import { useAtom } from 'jotai';
import { useCallback, useMemo } from 'react';
import { commentableTextAtomsAtom } from '@/atoms/comments';
import type { TextAtoms } from '@/types';

export function useCommentableTextAtoms() {
    const [textAtoms, setTextAtoms] = useAtom(commentableTextAtomsAtom);

    const register = useCallback(
        (textAtom: TextAtoms) => {
            if (textAtom.id) {
                setTextAtoms(prev => ({ ...prev, [textAtom.id]: textAtom }));
            }
        },
        [setTextAtoms],
    );

    const clear = useCallback(() => {
        setTextAtoms({});
    }, [setTextAtoms]);

    const textAtomIds = useMemo(() => Object.values(textAtoms).map(item => item.id), [textAtoms]);

    return { register, clear, textAtomIds, textAtoms };
}
